import React, { useEffect, useState, useRef } from 'react';
import SalesSummaryModal from './SalesSummaryModal';
import ApexCharts from 'apexcharts';
import InputBoxes from './inputBoxes';

export const StockSalesGraphView = (props) => {
  const [seriesData, setSeriesData] = useState([]);
  const [selectedBrand, setSelectedBrand] = useState(null);
  const [showSalesModal, setShowSalesModal] = useState(false);
  const [orderBy, setOrderBy] = useState("combinedStockValue");
  const [seriesDataColors, setSeriesDataColors] = useState([]);
  const [chartData, setChartData] = useState({
    options: {},
    series: [],
  });

  const [groupBy, setGroupBy] = useState('productBrand');
  const [visibleSeries, setVisibleSeries] = useState({
    totalCostValueGoodsSold: true,
    merchoidStockValue: true,
    sellingPriceGbp: false,
    totalProfit: false,
    aaaSales: true,
    aaaStockValue: true
  });



  const ApexChart = ({ options, series }) => {
    const chartRef = useRef(null);

    useEffect(() => {
      if (chartRef.current) {
        const chart = new ApexCharts(chartRef.current, { ...options, series });
        chart.render();

        return () => {
          chart.destroy();
        };
      }
    }, [options, series]);

    return <div ref={chartRef} />;
  };



  useEffect(() => {
    const getUniqueValues = (key) => {
      if (key === 'allItems') {
        return ['All Items'];
      }
      return Array.from(new Set(props.stock.map((item) => item[key])));
    };
    let categories = [];
    if (groupBy === 'productBrand') {
      categories = getUniqueValues('productBrand');
    } else if (groupBy === 'supplierName') {
      categories = getUniqueValues('supplierName');
    } else if (groupBy === 'productCategory') {
      categories = getUniqueValues('productCategory');
    } else if (groupBy === 'allItems') {
      categories = getUniqueValues('allItems');
    }

    // if (categories) {
    //   categories.sort();
    // }




    const merchoidSales = props.merchoidSales;
    const aaaSales = props.aaaSales
    const stockData = props.stock;


    const seriesDataSales = [];
    const aaaSeriesDataSales = []
    const seriesDataStockCost = [];
    const aaaSeriesDataStockValue = [];
    const seriesDataProfit = [];
    const aaaSeriesDataProfit = []
    const seriesDataSellingPriceGbp = [];
    const aaaSeriesDataSellingPriceGbp = []

    categories.forEach((category) => {
      let totalSalesPrice = 0;
      let merchoidStockValue = 0;
      let totalProfit = 0;
      let totalSellingPriceGbp = 0;
      let totalAaaSales = 0;
      let aaaTotalSalesPrice = 0
      let aaaTotalProfit = 0
      let aaaTotalSellingPriceGbp = 0
      let aaaTotalStockValue = 0

      if (category === 'All Items') {
        merchoidSales.forEach((item) => {
          totalSalesPrice += item.costPrice
          totalProfit += item.profit <= -9000 ? 0 : item.profit
          totalSellingPriceGbp += item.sellingPriceGbp
        });

        aaaSales.forEach((item) => {    
          console.log(item)
          aaaTotalSalesPrice += item.costPrice
          aaaTotalProfit += item.profit
          aaaTotalSellingPriceGbp += item.sellingPriceGbp
        });

        //calculate merhcoid stock value
        stockData.forEach((item) => {
          const latestQtyByDate = item.qtyByDate[item.qtyByDate.length - 1];
          if (latestQtyByDate && latestQtyByDate.length >= 1 && latestQtyByDate[1] !== null) {
            if (latestQtyByDate && latestQtyByDate[0]) {
              const qty = latestQtyByDate[1];
              merchoidStockValue += qty * item.productCost
            }
          }


          //calculate total aaa stock value
          if (item.aaaQtyByDate) {
            const aaaLatestQtyByDate = item.aaaQtyByDate[item.aaaQtyByDate.length - 1];
            if (aaaLatestQtyByDate && aaaLatestQtyByDate.length >= 1 && aaaLatestQtyByDate[1] !== null) {
              if (aaaLatestQtyByDate && aaaLatestQtyByDate[0]) {
                const qty = aaaLatestQtyByDate[1];
                aaaTotalStockValue += qty * item.aaaCostPrice
              }
            }
          }


        });
      } else {
        merchoidSales.forEach((item) => {
          if (item[groupBy] === category) {
            totalSalesPrice += item.costPrice;
            totalProfit += item.profit <= -9000 ? 0 : item.profit;
            totalSellingPriceGbp += item.sellingPriceGbp;
          }
        });

        aaaSales.forEach((item) => {
          if (item[groupBy] === category) {
            aaaTotalSalesPrice += item.costPrice;
            aaaTotalProfit += item.profit <= -9000 ? 0 : item.profit;
            aaaTotalSellingPriceGbp += item.sellingPriceGbp;
          }
        });


        stockData.forEach((item) => {
          if (item[groupBy] === category) {
            const latestQtyByDate = item.qtyByDate[item.qtyByDate.length - 1];
            if(latestQtyByDate && !isNaN(latestQtyByDate[1])){
              const qty = Number(latestQtyByDate[1])
              merchoidStockValue += parseFloat(qty) * parseFloat(item.productCost);
            }
            
            
            //calculate total aaa stock value
            if (item.aaaQtyByDate) {
              const aaaLatestQtyByDate = item.aaaQtyByDate[item.aaaQtyByDate.length - 1];
              if (aaaLatestQtyByDate && aaaLatestQtyByDate.length >= 1 && aaaLatestQtyByDate[1] !== null) {
                if (aaaLatestQtyByDate && aaaLatestQtyByDate[0]) {

                  const qty = Number(aaaLatestQtyByDate[1]);
                  aaaTotalStockValue += parseFloat(qty) * parseFloat(item.aaaCostPrice)

                }
              }
            }


          }
        });
      }
      seriesDataProfit.push(totalProfit.toFixed(2));
      aaaSeriesDataProfit.push(aaaTotalProfit.toFixed(2))

      seriesDataSales.push(totalSalesPrice.toFixed(2));
      aaaSeriesDataSales.push(aaaTotalSalesPrice.toFixed(2))

      seriesDataStockCost.push(merchoidStockValue.toFixed(2));
      aaaSeriesDataStockValue.push(aaaTotalStockValue.toFixed(2));
      seriesDataSellingPriceGbp.push(totalSellingPriceGbp.toFixed(2))
      aaaSeriesDataSellingPriceGbp.push(aaaTotalSellingPriceGbp.toFixed(2))
    });


    const categoryValues = categories.map((category, index) => ({
   
      category,
      totalSalesPrice: parseFloat(seriesDataSales[index]),
      aaaTotalSalesPrice: parseFloat(aaaSeriesDataSales[index]),
      merchoidStockValue: parseFloat(seriesDataStockCost[index]),
      totalProfit: parseFloat(seriesDataProfit[index]),
      aaaTotalProfit: parseFloat(aaaSeriesDataProfit[index]),
      totalSellingPriceGbp: parseFloat(seriesDataSellingPriceGbp[index]),
      aaaTotalSellingPriceGbp: parseFloat(seriesDataSellingPriceGbp[index]),
      aaaTotalSalesValue: parseFloat(aaaSeriesDataSales[index]),
      aaaTotalStockValue: parseFloat(aaaSeriesDataStockValue[index]),
      combinedStockValue: parseFloat(seriesDataStockCost[index]),

    }));


    const sortedCategoryValues = getSortedCategoryValues(categoryValues);
    const sortedCategories = sortedCategoryValues.map((item) => item.category);
    const sortedSeriesDataSales = sortedCategoryValues.map((item) => item.totalSalesPrice);
    const sortedAaaSeriesDataSales = sortedCategoryValues.map((item) => item.aaaTotalSalesValue)
    const sortedAaaSeriesDataStock = sortedCategoryValues.map((item) => item.aaaTotalStockValue)
    const sortedSeriesDataStockCost = categoryValues.map((item) => item.merchoidStockValue);
    const sortedSeriesDataProfit = categoryValues.map((item) => item.totalProfit);
    const sortedSeriesDataSellingPriceGbp = categoryValues.map((item) => item.totalSellingPriceGbp);






    const seriesDataDummy = [];
    // Create an object to hold the sales sources
    const salesSourceData = {};


    // Add the sales sources to the series data
    for (const source in salesSourceData) {
      seriesDataDummy.push(salesSourceData[source]);
    }


    seriesDataDummy.push({
      name: "Merchoid Cost Goods Sold",
      group: 'sales',
      data: seriesDataSales
    });
    seriesDataDummy.push({
      name: "AAA Cost Goods Sold",
      group: 'sales',
      data: aaaSeriesDataSales
    });
    seriesDataDummy.push({
      name: "Merchoid Stock Value",
      data: seriesDataStockCost
    });
    seriesDataDummy.push({
      name: "Merchoid Profit",
      data: seriesDataProfit
    });
    seriesDataDummy.push({
      name: "Selling Price GBP",
      data: seriesDataSellingPriceGbp
    });

    seriesDataDummy.push({
      name: "AAA Stock Value",
      data: aaaSeriesDataStockValue
    });
  


    setSeriesDataColors(seriesDataColors);
    setSeriesData(seriesDataDummy)


    setChartData({
      options: {
        plotOptions: {
          bar: {
            horizontal: false,
            
          }
        },
        chart: {
          height: 725,
          width: 1800,
          id: 'chart',
          type: 'bar',
          events: {
            dataPointSelection: (event, chartContext, config) => {
              const thisBrand = config.w.config.xaxis.categories[config.dataPointIndex];
              setSelectedBrand(thisBrand);
              setShowSalesModal(true)

            }

          },
          stacked: true
        },
        yaxis: {
          title: {
            text: 'Value (£)',
          },
          labels: {
            formatter: function (value) {
              return "£" + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            },
          },
        },
        xaxis: {
          categories: sortedCategories,
          title: {
            text: [groupBy]
          },

        },
        custom: function (val, { seriesIndex, dataPointIndex, w }) {
          if (w.config.series[seriesIndex].name === 'Merchoid Sales' || w.config.series[seriesIndex].name === 'AAA Sales') {
            console.log(w.config.series)
            //get index of stock value
            const merchoidStockValueSeries = w.config.series.filter((x) => x.name === 'Merchoid Stock Value')
            const aaaStockValueSeries = w.config.series.filter((x) => x.name === 'AAA Stock Value')
            const merchoidSalesSeres = w.config.series.filter((x) => x.name === 'Merchoid Sales')
            const aaaSalesSeres = w.config.series.filter((x) => x.name === 'AAA Sales')


            const merchoidStockValue = merchoidStockValueSeries[0].data[dataPointIndex]
            const aaaStockValue = aaaStockValueSeries[0].data[dataPointIndex]
            const merchoidSalesValue = merchoidSalesSeres[0].data[dataPointIndex]
            const aaaSalesValue = aaaSalesSeres[0].data[dataPointIndex]

            const merchoidRatio = merchoidSalesValue / merchoidStockValue;
            const aaaRatio = aaaSalesValue / aaaStockValue

            return `£${merchoidSalesValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} (${merchoidRatio.toFixed(2)}x)
              £${aaaSalesValue.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} (${aaaRatio.toFixed(2)}x)`
          }
        },
        tooltip: {
          custom: function ({ series, seriesIndex, dataPointIndex, w }) {

            let isSalesSeries = w.config.series[seriesIndex].name.toLowerCase().includes('sales');
            let isStockSeries = w.config.series[seriesIndex].name.toLowerCase().includes('stock');

            let salesValue1, salesValue2, stockValue1, stockValue2, ratio1, ratio2, combinedSales, combinedStock, combinedRatio;
            let existsSales1 = false, existsSales2 = false, existsStock1 = false, existsStock2 = false;

            for (let i = 0; i < w.config.series.length; i++) {
              if (w.config.series[i].name === 'Merchoid Sales') {
                salesValue1 = w.globals.series[i][w.globals.labels.indexOf(w.globals.labels[dataPointIndex])];
                existsSales1 = true;
              }
              else if (w.config.series[i].name === 'AAA Sales') {
                salesValue2 = w.globals.series[i][w.globals.labels.indexOf(w.globals.labels[dataPointIndex])];
                existsSales2 = true;
              }
              else if (w.config.series[i].name === 'Merchoid Stock Value') {
                stockValue1 = w.globals.series[i][w.globals.labels.indexOf(w.globals.labels[dataPointIndex])];
                existsStock1 = true;
              }
              else if (w.config.series[i].name === 'AAA Stock Value') {
                stockValue2 = w.globals.series[i][w.globals.labels.indexOf(w.globals.labels[dataPointIndex])];
                existsStock2 = true;
              }
            }

            if (existsSales1 && existsStock1) {
              ratio1 = stockValue1 / salesValue1;
            }

            if (existsSales2 && existsStock2) {
              ratio2 = stockValue2 / salesValue2;
            }

            if (existsSales1 && existsSales2 && existsStock1 && existsStock2) {
              combinedSales = salesValue1 + salesValue2;
              combinedStock = stockValue1 + stockValue2;
              combinedRatio = combinedStock / combinedSales;
            }

            let tooltipContent = '<div style="padding: 10px;">';

            if (isSalesSeries) {
              if (existsSales1) {
                tooltipContent += `<div style="margin-bottom: 5px;"><span style="display: inline-block; width: 10px; height: 10px; margin-right: 5px;"></span><strong>Merchoid Sales: </strong> £${salesValue1.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}<Strong> ${existsStock1 ? 'Merchoid Sales Ratio:' + ratio1.toFixed(2) + 'x' : ''}</Strong></div>`;
              }

              if (existsSales2) {
                tooltipContent += `<div style="margin-bottom: 5px;"><span style="display: inline-block; width: 10px; height: 10px; margin-right: 5px;"></span><strong>AAA Sales: </strong> £${salesValue2.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}<Strong> ${existsStock2 ? 'AAA Sales Ratio: ' + ratio2.toFixed(2) + 'x' : ''} </Strong></div>`;
              }

              if (existsSales1 && existsSales2 && existsStock1 && existsStock2) {
                tooltipContent += `<div style="background-color: #f2f2f2; padding: 5px; border-radius: 5px;"><span style="display: inline-block; width: 10px; height: 10px;  margin-right: 5px;"></span><strong>Combined Sales: </strong> £${combinedSales.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}<Strong> Combined Sales Ratio: ${combinedRatio.toFixed(2)}x</Strong></div>`;

              }
            } else if (isStockSeries) {
              if (existsStock1) {
                tooltipContent += `<div style="margin-bottom: 5px;"><span style="display: inline-block; width: 10px; height: 10px; margin-right: 5px;"></span><strong>Merchoid Stock: </strong> £${stockValue1.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</div>`;
              }
              if (existsStock2) {
                tooltipContent += `<div style="margin-bottom: 5px;"><span style="display: inline-block; width: 10px; height: 10px; margin-right: 5px;"></span><strong>AAA Stock: </strong> £${stockValue2.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</div>`;
              }
              if (existsStock1 && existsStock2) {
                tooltipContent += `<div style="background-color: #f2f2f2; padding: 5px; border-radius: 5px;"><span style="display: inline-block; width: 10px; height: 10px;  margin-right: 5px;"></span><strong>Combined Stock: </strong> £${combinedStock.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}</div>`;
              }
            }

            tooltipContent += "</div>";

            return tooltipContent;
          }
        },


        dataLabels: {
          enabled: false,
          formatter: function (val, { seriesIndex, dataPointIndex, w }) {
            if (seriesIndex === 1) {
              // display ratio on green bar
              const blueValue = w.globals.series[0][dataPointIndex];
              const ratio = val / blueValue;

              return `£${val.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')} (${ratio.toFixed(2)}x)`;
            } else {
              // display value on blue bar
              return `£${val.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')}`;
            }
          }
        },
      },


      series: [
        visibleSeries.totalCostValueGoodsSold && {
          name: 'Merchoid Sales',
          group: 'actual',
          data: sortedSeriesDataSales,
          clickable: true,
        },
        visibleSeries.aaaSales && {
          name: "AAA Sales",
          group: 'actual',
          data: sortedAaaSeriesDataSales,
          clickable: true,
        },
        visibleSeries.aaaStockValue && {
          name: 'AAA Stock Value',
          group: 'stockValue',
          data: sortedAaaSeriesDataStock,
          clickable: true,
        },

        visibleSeries.merchoidStockValue && {
          name: 'Merchoid Stock Value',
          group: 'stockValue',
          data: sortedSeriesDataStockCost,
          clickable: true,
        },
        visibleSeries.sellingPriceGbp && {
          name: 'Selling Price GBP',
          group: 'budget',
          data: sortedSeriesDataSellingPriceGbp,
          clickable: true,
        },
        visibleSeries.totalProfit && {
          name: 'Total Profit',
          group: 'budget',
          data: sortedSeriesDataProfit,
          clickable: true,
        },
      ].filter(Boolean),

    });

  }, [props.merchoidSales, props.aaaSales, props.stock, groupBy, visibleSeries, orderBy]);

  const handleGroupByChange = (event) => {
    setGroupBy(event.target.value);
  };

  const handleCheckboxChange = (event) => {
    const { name, checked } = event.target;
    setVisibleSeries((prevState) => ({ ...prevState, [name]: checked }));
  };


  // New function to handle sorting
  const getSortedCategoryValues = (categoryValues) => {
    return categoryValues.sort((a, b) => {
      if (orderBy === "merchoidStockValue") {
        return b.merchoidStockValue - a.merchoidStockValue;
      } else if (orderBy === "totalSellingPrice") {
        return b.totalSellingPriceGbp - a.totalSellingPriceGbp;
      } else if (orderBy === "totalSalesValue") {
        return b.totalSalesPrice - a.totalSalesPrice;
      } else if (orderBy === "totalProfit") {
        return b.totalProfit - a.totalProfit;
      } else if (orderBy === 'combinedStockValue') {
        return b.combinedStockValue - a.combinedStockValue
      }
      return 0;
    });
  };






  return <div>
    <select disabled={props.loading} value={props.startDateDaysFromNow} onChange={(e) => props.onChangeStartDate(e)}>
      <option value="30">30 days</option>
      <option value="60">60 days</option>
      <option value="90">90 days</option>
      <option value="180">180 days</option>
      <option value="365">365 days</option>
    </select>

    <select onChange={handleGroupByChange}>
      <option value="productBrand">Brand</option>
      <option value="supplierName">Supplier</option>
      <option value="productCategory">Category</option>
      <option value="allItems">All Items</option>
    </select>

    <select onChange={(e) => setOrderBy(e.target.value)}>
    <option value="combinedStockValue">Combined Stock Value</option>
      <option value="merchoidStockValue">Merchoid Stock Value</option>
      <option value="totalSellingPrice">Total Selling Price</option>
      <option value="totalSalesValue">Total Sales Value</option>
      <option value="totalProfit">Total Profit</option>
    </select>
    <div>
      <input
        type="checkbox"
        name="aaaSales"
        checked={visibleSeries.aaaSales}
        onChange={handleCheckboxChange}
      />
      <label>AAA Sales</label>
    </div>
    <div>
      <input
        type="checkbox"
        name="totalCostValueGoodsSold"
        checked={visibleSeries.totalCostValueGoodsSold}
        onChange={handleCheckboxChange}
      />
      <label>Merchod Sales</label>
    </div>
    <div>
      <input
        type="checkbox"
        name="merchoidStockValue"
        checked={visibleSeries.merchoidStockValue}
        onChange={handleCheckboxChange}
      />
      <label>Merchoid Stock Value</label>
    </div>
    <div>
      <input
        type="checkbox"
        name="aaaStockValue"
        checked={visibleSeries.aaaStockValue}
        onChange={handleCheckboxChange}
      />
      <label>AAA Stock Value</label>
    </div>
    <div>
      <input
        type="checkbox"
        name="sellingPriceGbp"
        checked={visibleSeries.sellingPriceGbp}
        onChange={handleCheckboxChange}
      />
      <label>Selling Price GBP</label>
    </div>
    <div>
      <input
        type="checkbox"
        name="totalProfit"
        checked={visibleSeries.totalProfit}
        onChange={handleCheckboxChange}
      />
      <label>Merchoid Profit</label>
    </div>






    {!props.loading && <ApexChart
      options={chartData.options}
      series={chartData.series}


    />}

    {!props.loading && <InputBoxes
      setExclusions={props.setExclusions}
      setIsInclusion={props.setIsInclusion}
      isInclusion={props.isInclusion}
      isBadStockBool={props.isBadStockBool}
      setIsBadStockBool={props.setIsBadStockBool}
      onToggleBadStock={props.onToggleBadStock}
    />}

    {/* render the modal if a brand is selected */}
    {selectedBrand && showSalesModal && (
      <SalesSummaryModal
        brand={selectedBrand}
        merchoidSales={props.merchoidSales}
        aaaSales={props.aaaSales}
        stock={props.stock}
        showSalesModal={showSalesModal}
        setShowSalesModal={setShowSalesModal}
        groupBy={groupBy}

      />
    )}

    <div>
      Merchoid Stock Value is £{props.stock.reduce((acc, product) => acc + (product.qtyByDate.length > 0 ? product.productCost * product.qtyByDate[product.qtyByDate.length - 1][1] : 0), 0)}

    </div>

    <div>AAA Stock Value is £{props.stock.reduce((acc, product) => acc + (product.aaaCostPrice * product.aaaQtyByDate[product.aaaQtyByDate.length - 1][1]), 0)}</div>

    <div>
      Total Stock Value is £{props.stock.reduce((acc, product) => acc + (product.aaaCostPrice * product.aaaQtyByDate[product.aaaQtyByDate.length - 1][1]) + (product.qtyByDate.length > 0 ? product.productCost * product.qtyByDate[product.qtyByDate.length - 1][1] : 0), 0)}

    </div>

  </div>


}



